import React, { useState } from "react";
import { TextField, IconButton, InputAdornment, Button,Typography } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function  CustomInput({
  label,
  value,
  onChange,
  editable,
  error,
  type,
  name,
  readOnly,
  matchPassword,
  defaultValue,
  multiline,
  placeholder,
  buttonText,
  button,
  handleView,
  disabled: disabledProp = false,
  autoComplete,
  pendingValue
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [change, setChange] = useState(false);
  const isDisabled = Boolean(editable || disabledProp || readOnly);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleInput = (e) => {
    if (isDisabled) return;
    setChange(true);
    onChange(name, e.target.value, matchPassword);
  };

  // Decide which value to show:
  // - Before user types, show defaultValue (e.g. from existing data)
  // - If parent updates `value` programmatically (like synced fields), prefer that
  // - After user types (`change === true`), always show `value`
  const displayedValue = change ? value : (value ?? defaultValue);

  return (
    <div>
      <TextField
        fullWidth
        disabled={isDisabled}
        label={label}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={displayedValue}
        name={name}
        type={showPassword ? "text" : type}
        onChange={handleInput}
        error={error !== ""}
        helperText={error}
        multiline={multiline}
        inputProps={{ readOnly: readOnly }}
        rows={multiline ? 4 : 1}
        sx={{
          "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: "#f5f5f5",
            color: "#6b7280",
          },
          "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
            borderColor: "#d1d5db",
          },
          "& .MuiInputLabel-root.Mui-disabled": {
            color: "#9ca3af",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#6b7280",
          },
        }}
        FormHelperTextProps={{
          sx:{
            ml:0,
            mt:0
          }
        }}
        InputProps={{
          // readOnly: readOnly ,
          sx: {
            borderRadius: "8px",
            my: 1,
            fontSize: "14px",
            fontWeight: "400",
            backgroundColor: isDisabled ? "#f5f5f5" : "inherit",
          },
          endAdornment: (
            <InputAdornment position="end">
              {(name === "password" || name === "confirmPassword") && (
                <IconButton onClick={handleShowPassword} sx={{ minWidth: "auto" }} disabled={isDisabled}>
                  {showPassword ? <RemoveRedEyeOutlinedIcon /> : <VisibilityOffIcon />}
                </IconButton>
              )}
              {button && (
                <Button
                  variant="contained" onClick={handleView} disabled={isDisabled}

                  sx={{ ml: 1, fontSize:"12px",fontWeight: "400", borderRadius:"23px", boxShadow:"none",textTransform: "capitalize", py: "3px" }}
                >
                  {button}
                </Button>
              )}

              {buttonText && (
                <Button
                  onClick={handleView}
                  variant="contained"
                  disabled={isDisabled}
                  sx={{ ml: 1,fontSize:"12px",fontWeight: "400", borderRadius:"23px", boxShadow:"none",textTransform: "capitalize", py:"3px" }}
                >
                  {buttonText}
                </Button>
              )}
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
      />
      {pendingValue && (
        <Typography sx={{ fontSize: '12px', color: '#f29339', mt: 0 }}>
          Pending &rarr; {pendingValue}
        </Typography>
      )}
    </div>
  );
}

export default CustomInput;
